import { Box, Paper } from '@material-ui/core';
import { Exception, SchemaErrorException } from '@nemuru-eng/js-api-client';

import { ErrorMessageAdditionalDetails } from '@/components/shared/components/ErrorBoundary/components/ErrorMessage/components/ErrorMessageAdditionalDetails';
import { ErrorMessageFactory } from '@/components/shared/components/ErrorBoundary/components/ErrorMessage/components/ErrorMessageFactory/ErrorMessageFactory';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface ErrorMessagePaperProps {
  error: Error | Exception | SchemaErrorException;
}

export const ErrorMessagePaper = ({ error }: ErrorMessagePaperProps) => {
  const { palette } = useCustomTheme();

  if (!error) return null;

  return (
    <Paper
      elevation={0}
      style={{
        backgroundColor: palette.error.main,
        color: palette.error.contrastText,
        width: 'max-content',
        minWidth: '50%',
        maxWidth: '100%',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <Box padding={'15px 20px'}>
        <ErrorMessageFactory error={error} />
        <ErrorMessageAdditionalDetails />
      </Box>
    </Paper>
  );
};
